import {createSlice} from '@reduxjs/toolkit';
import type {PageContent} from '@gravity-ui/page-constructor';

export interface PromoState {
    content: PageContent;
}

const initialState: PromoState = {
    content: {
        blocks: [],
    },
};

export const {actions, reducer} = createSlice({
    name: 'promo',
    initialState,
    reducers: {},
});

export const selectPromoContent = (state: WikiState) => state.promo.content;
